import { render, staticRenderFns } from "./successprescriptList.vue?vue&type=template&id=d638a646&scoped=true"
import script from "./successprescriptList.vue?vue&type=script&lang=js"
export * from "./successprescriptList.vue?vue&type=script&lang=js"
import style0 from "./successprescriptList.vue?vue&type=style&index=0&id=d638a646&prod&scoped=true&lang=css"
import style1 from "./successprescriptList.vue?vue&type=style&index=1&id=d638a646&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d638a646",
  null
  
)

export default component.exports